import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable import/no-named-as-default */

/*
 * @Author: wangshengqiang
 * @Date: 2021-02-26 16:06:10
 * @LastEditTime: 2022-02-28 14:52:15
 * @LastEditors: wangshengqiang
 * @Description: 组件和json配置的组件名称映射关系
 */
import Banner from './Banner';
import RowInput from './RowInput';
import RowRadioList from './RowRadioList';
import RowDate from './RowDate';
import RowSelect from './RowSelect';
import CertNo from './CertNo';
import Title from './Title';
import AnchorTabs from './AnchorTabs';
import PhoneNo from './PhoneNo';
import ValidateCode from './ValidateCode';
import Images from './Images';
import ClaimSteps from './ClaimSteps';
import ClaimFlow from './ClaimFlow';
import Question from './Question';
import InsurancePlanDesc from './InsurancePlanDesc';
import IconButton from './IconButton';
import ConsultIconButton from './ConsultIconButton';
import ProductTitle from './ProductTitle';
import HealthInsureRule from './HealthInsureRule';
import HealthNotifyForHengQin from './HealthNotifyForHengQin';
import HolderRelation from './HolderRelation';
import Clause from './Clause';
import ChooseIsInsured from './ChooseIsInsured';
import ChooseEnumBtn from './ChooseEnumBtn';
import ChooseEnumPeriod from './ChooseEnumPeriod';
import InsuranceStartDate from './InsuranceStartDate';
import PaymentFrequency from './PaymentFrequency';
import BankAccountName from './BankAccountName';
import CustomerService from './CustomerService';
import Premium from './Premium';
import SimpleButton from './SimpleButton';
import GuaranteeDutyConfirm from './GuaranteeDutyConfirm';
import InformationList from './InformationList';
import { infoText as HolderNotice } from './HolderNotice';
import InsurancePlanSelect from './InsurancePlanSelect';
import HealthNotificationList from './HealthNotificationList'; // 健康告知列表

import ConfirmOrderInfo from './ConfirmOrderInfo'; // 订单信息确认

import ConfirmHolderInfo from './ConfirmHolderInfo'; // 投保人信息确认

import ConfirmInsurantInfo from './ConfirmInsurantInfo'; // 被保人信息确认

import ConfirmBeneficiary from './ConfirmBeneficiary';
import ConfirmCommon from './ConfirmCommon';
import FullscreenTipsModule from './Supervision/fullscreenTipsModule/index.js';
import TooltipFullScreen from './Supervision/tooltipFullScreen/index.js';
import { Watermark } from './Supervision/Watermark';
import { BubbleTip, SupervisionPopup } from './Supervision/index';
import CalculateTrial from './CalculateTrial';
import Beneficiary from './Beneficiary';
import Insurant from './Insurant';
import RowCertValidity from './RowCertValidity';
import RowArea from './RowArea';
import RowCareer from './RowCareer';
import Toolbar, { SimpleRemark } from './Toolbar';
import FixedBottom from './FixedBottom/FixedBottom.js';
import PlanTabs from './PlanTabs';
import PlanTab from './PlanTab';
import BenefitDemonstration from './BenefitDemonstration';
import BenefitDemonstrationBar from './BenefitDemonstrationBar';
import BenefitDemonstrationFactor from './BenefitDemonstrationFactor';
import BenefitDemonstrationTable from './BenefitDemonstrationTable';
import BenefitDemonstrationSlider from './BenefitDemonstrationSlider';
import RowSex from './RowSex';
import Email from './Email';
import Name from './Name';
import RowBirthday from './RowBirthday';
import PersonalAnnualIncome from './PersonalAnnualIncome';
import Modal, { text, picture, params } from './Modal';
import RowPlanBrief from './RowPlanBrief';
import AnchorTabsModule from './AnchorTabsModule';
import HealthTextEdit from './HealthTextEdit';
import ClauseModule from './ClauseModule';
import insureResult, { insureResultChannel, insureResultSuccess, insureResultFail, insureResultDescription, insureResultText, insureResultBtn, insureOrderInfo, adBanner } from './InsureResult/index.js';
import QuestionMore from './QuestionMore';
import Holder from './Holder';
import IdValidateCode from './JDvalidateCode';
import Banks from './Banks'; // eslint-disable-next-line import/no-cycle

import PolicyholdersExemptionModule from './PolicyholdersExemptionModule';
import InsurancePeriod from './InsurancePeriod';
import InsureEndDate from './InsureEndDate';
import AgentNotifyForHengQin from './AgentNotifyForHengQin';
import InsuranceResultForHengQin from './InsuranceResultForHengQin';
import NavBarWithAirSignature from './NavBarWithAirSignature';
import IdentityVerificationOfInsuredAndHolder from './IdentityVerificationOfInsuredAndHolder';
import IncomingTips from './IncomingTips';
import RowNation from './RowNation';
import CertAttachment from './CertAttachment'; // import SignatureVerify from './SignatureVerify';

import TotalSumInsured from './TotalSumInsured';
import BankAccType from './BankAccType';
import SumAssured from './SumAssured';
import WeddingReceptionDate from './WeddingReceptionDate';
import BtnGroup from './BtnGroup';
import HolderSign from './HolderSign';
import InsurerSign from './InsurerSign';
import AgentSign from './AgentSign';
import CertImage from './CertImage';
import BaseModule from './BaseModule';
import InsuredWithPlanSelectModule, { InsuredWithPlanSelect, InsuredPlanSelect } from './InsuredWithPlanSelectModule';
import Form from './Form';
const commonFieldsMap = {
  RowInput,
  RowRadioList,
  RowDate,
  RowSelect
};
const ModuleCompoents = {
  BaseModule,
  clauseModule: ClauseModule,
  policyholdersExemptionModule: PolicyholdersExemptionModule // "modalModule": ModalModule,

}; // 投保人主体为企业的要素

const companyFieldsMap = {
  contactRegion: RowArea,
  // 联系人地区
  contactName: RowInput,
  //  联系人姓名
  contactPhoneNo: RowInput,
  // 联系人手机
  contactNo: RowInput,
  companyCategory: RowSelect,
  //  企业种类
  businessScope: RowInput,
  // 经营范围
  industryName: RowInput,
  //  行业名称
  weddingBanquetTableNum: RowRadioList,
  // 酒桌系数
  weddingBanquetAdress: RowInput,
  // 婚宴举办地址
  weddingReceptionDate: WeddingReceptionDate // 婚宴举办日期

};

const mappings = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, ModuleCompoents), commonFieldsMap), companyFieldsMap), {}, {
  bannerPicButton: Banner,
  bannerPicture: Banner,
  bannerVideoText: Banner,
  // 头图组件
  bannerPicText: Banner,
  // 头图
  bannerPicVideo: Banner,
  // 头图
  bannerFull: Banner,
  // 头图(支持全样式)
  certNo: CertNo,
  title: Title,
  anchorTabs: AnchorTabs,
  phoneNo: PhoneNo,
  validateCode: ValidateCode,
  productPicture: Images,
  images: Images,
  steps: ClaimSteps,
  claimFlow: ClaimFlow,
  healthQuestion: Question,
  gender: RowSex,
  name: Name,
  birthday: RowBirthday,
  certType: RowSelect,
  holderRelation: HolderRelation,
  healthGuaranteeDuty: InsurancePlanDesc,
  iconButton: IconButton,
  consultIconButton: ConsultIconButton,
  healthCustomerService: CustomerService,
  productTitle: ProductTitle,
  healthInsureRule: HealthInsureRule,
  healthClause: Clause,
  ChooseIsInsured,
  ChooseEnumBtn,
  ChooseEnumPeriod,
  insuranceStartDate: InsuranceStartDate,
  paymentFrequency: PaymentFrequency,
  bankAccount: RowInput,
  paymentWay: RowSelect,
  bankAccountName: BankAccountName,
  healthPremium: Premium,
  healthSimpleButton: SimpleButton,
  healthGuaranteeDutyConfirm: GuaranteeDutyConfirm,
  // 保障详情
  informationList: InformationList,
  healthInfoText: HolderNotice,
  planSelect: InsurancePlanSelect,
  healthNotificationList: HealthNotificationList,
  // 健康告知列表
  infoConfirm: ConfirmOrderInfo,
  // 信息确认
  holderConfirm: ConfirmHolderInfo,
  // 投保人信息确认
  insurantConfirm: ConfirmInsurantInfo,
  // 被保人信息确认
  beneficiaryConfirm: ConfirmBeneficiary,
  commonConfirm: ConfirmCommon,
  fullscreenTipsModule: FullscreenTipsModule,
  tooltip: BubbleTip,
  supervision: SupervisionPopup,
  trailElement: CalculateTrial,
  beneficiary: Beneficiary,
  benefitSpecialType: RowSelect,
  beneficiaryType: RowSelect,
  insurant: Insurant,
  certValidatePeriod: RowCertValidity,
  email: Email,
  region: RowArea,
  personalAnnualIncome: PersonalAnnualIncome,
  address: RowInput,
  occupation: RowCareer,
  benefitRatio: RowInput,
  benefitOrder: RowSelect,
  benefitDistributeMode: RowSelect,
  insurantRelation: RowRadioList,
  healthToolbarModule: Toolbar,
  healthFixedBottom: FixedBottom,
  planTabs: PlanTabs,
  planTab: PlanTab,
  // modalModule: () => {
  //   return null;
  // },
  text,
  healthSimpleRemark: SimpleRemark,
  benefitDemonstration: BenefitDemonstration,
  benefitDemonstrationFactor: BenefitDemonstrationFactor,
  benefitDemonstrationBar: BenefitDemonstrationBar,
  benefitDemonstrationTable: BenefitDemonstrationTable,
  benefitDemonstrationSliderModule: BenefitDemonstration,
  // 利益演示滑动图模块
  benefitDemonstrationSlider: BenefitDemonstrationSlider,
  hasSocialInsurance: RowRadioList,
  rowHeader: RowPlanBrief,
  healthTabsModule: AnchorTabsModule,
  healthTextEdit: HealthTextEdit,
  smoking: RowRadioList,
  tooltipFullScreen: TooltipFullScreen,
  watermark: Watermark,
  healthInsureResult: insureResult,
  // 投保结果
  healthInsureResultChannel: insureResultChannel,
  healthInsureResultChannelH5: insureResultChannel,
  healthInsureResultChannelWeChat: insureResultChannel,
  healthInsureResultSuccess: insureResultSuccess,
  healthInsureResultFail: insureResultFail,
  healthInsureResultDescription: insureResultDescription,
  healthInsureResultText: insureResultText,
  healthInsureResultBtn: insureResultBtn,
  healthInsureOrderInfo: insureOrderInfo,
  advert: adBanner,
  healthQuestionMore: QuestionMore,
  // 更多问题
  objectAddress: RowInput,
  recommenderNo: RowInput,
  holder: Holder,
  idValidateCode: IdValidateCode,
  // 通用信息的验证吗（银行验证码）
  paymentMethod: RowSelect,
  // 付款方式
  bankCode: Banks,
  // 2021-11-12
  emailAddress: RowInput,
  insurancePeriod: InsurancePeriod,
  // 通用要素-保障期间
  insuranceEndDate: InsureEndDate,
  // 通用要素-终保日期
  // 横琴追加组件
  HealthNotifyForHengQin,
  AgentNotifyForHengQin,
  InsuranceResultForHengQin,
  IdentityVerificationOfInsuredA: IdentityVerificationOfInsuredAndHolder,
  NavBarWithAirSignature,
  incomingTips: IncomingTips,
  modal: Modal,
  picture,
  height: RowInput,
  // 身高
  weight: RowInput,
  // 体重
  insureRegion: RowArea,
  // 投保地区
  zipCode: RowInput,
  // 邮编
  nationality: RowNation,
  // 国籍
  affiliation: RowSelect,
  // 被保险人所属单位
  workUnit: RowInput,
  familiesBuyFlag: RowRadioList,
  // 家属是否购买过保险
  certAttachment: CertAttachment,
  // 证件附件
  // SignatureVerify,
  TotalSumInsured,
  // 保费算保额- 保额显示
  bankAccType: BankAccType,
  // 银行账户类型
  sumAssured: SumAssured,
  isTaxResident: RowRadioList,
  // 是否为税收居民
  planId: InsuredPlanSelect,
  // 瑞恒被保人保障计划
  InsuredWithPlanSelect,
  // 瑞恒被保人列表
  InsuredWithPlanSelectModule,
  // 瑞恒被保人列表模块
  HolderSign,
  AgentSign,
  InsurerSign,
  // params,
  btnGroup: BtnGroup,
  // 按钮操作栏
  certImage: CertImage // 证件影像上传

});

export default mappings;